export default __webpack_public_path__ + "images/BS.fd9e127.png";